var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEraseOff = function SvgEraseOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.075 21.9-4.025-4-1.75 1.8q-.15.15-.338.225-.187.075-.387.075h-7.4q-.2 0-.388-.075a1 1 0 0 1-.337-.225l-1.825-1.825q-.575-.575-.588-1.425-.012-.85.563-1.45l4.7-4.85-5.225-5.225q-.3-.3-.3-.712 0-.413.3-.713t.712-.3.713.3l17 17q.3.3.3.7t-.3.7-.712.3a.97.97 0 0 1-.713-.3M5.6 18h6.55l1.475-1.525L8.7 11.55 4 16.4zm12.275-2.975L16.45 13.6 20 9.95 15.05 5 11.5 8.65l-1.4-1.4 3.5-3.65q.575-.6 1.412-.6.838 0 1.413.575L21.4 8.55q.575.575.575 1.425T21.4 11.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEraseOff);
export { ForwardRef as ReactComponent };